import { defineStore } from '@/utils/store'
import { createJSONStorage } from 'zustand/middleware'
import { WEB_SEARCH_QUERY } from '@/env'

export type SessionState = {
  // 初始化時收到的參數
  params: Partial<Record<WEB_SEARCH_QUERY, string>>
  // 是否可以按返回
  canBack: boolean
  // 暫存語系
  locale?: string
  // OCR 掃描結果快取
  ocrDataCache?: Record<string, string | null | undefined>

  // 往下擴充
}

/** 存放 sessionStorage */
export const [useSessionStore, setSessionState] = defineStore<SessionState>(
  {
    params: {},
    canBack: false,
  },
  {
    name: 'SESSION',
    storage: createJSONStorage(() => sessionStorage),
    partialize: (state) => ({ ...state, params: { ...state.params, simple: undefined } }) as SessionState,
  },
)

/** 刪除指定的 storage key */
export const deleteSessionItem = (key: string) => {
  try {
    window?.localStorage?.removeItem(key.toUpperCase())
  } catch {
    // ignore
  }
}
